<!-- 
  - Custom Select Component
 -->

<!-- TODO: Keyboard Navigation -->
<div
  class="select"
  id="{{ selectId }}"
  [ngStyle]="{ '--width': isFullWidth() ? '100%' : width() }"
>
  <div
    class="select-button {{ size() }} {{ class() }}"
    role="combobox"
    aria-labelledby="select button"
    aria-haspopup="listbox"
    aria-expanded="false"
    aria-controls="dropdown"
    (click)="toggle()"
    id="toggle-button"
    tabindex="0"
    (keydown.enter)="toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
  >
    @if (ref.children.length === 0) {
      <div class="default-content">
        @if (type() === 'select') {
          <div>
            <span class="selected-value">{{
              selectedOption?.value || placeholder()
            }}</span>
          </div>
        } @else if (type() === 'check') {
          <div class="check-preview">
            <span>{{ name() }}</span>
            <span class="checked-count">{{ checkedCount }}</span>
          </div>
        }
      </div>
    }

    <div #ref class="injected-content"><ng-content></ng-content></div>

    <span class="arrow-down">
      <ng-icon name="navArrowDown" size="20"></ng-icon>
    </span>
  </div>

  <div
    class="dropdown"
    id="dropdown"
    data-simplebar
    data-simplebar-auto-hide="false"
    role="listbox"
  >
    @if (!disableSearch()) {
      <div class="search mb-2">
        <app-input
          iconName="search"
          [placeholder]="dictionaryService.get('Search')"
          class="search"
          [size]="'sm'"
          (onChange)="filterOptions($event)"
        ></app-input>
      </div>
    }
    <ul class="options">
      @if (type() === 'check' && lastSearchQuery === '') {
        <label role="option" class="selectAll option">
          @if (type() === 'check') {
            <input
              type="checkbox"
              (click)="checkAll()"
              name="Select All"
              value="All"
              [checked]="allChecked"
            />
          }
          <span class="value">{{ dictionaryService.get('SelectAll') }}</span>
        </label>
      }
      <!--
        Displaying filtered options
        ** Class of selected is only available for the "select" mode
        -->
      @for (option of filteredOptions; track option.id; let i = $index) {
        <li
          class="option"
          [ngClass]="{
            selected: selectedOption?.id === option.id && type() === 'select',
          }"
          role="option"
        >
          <!-- Component has two modes, "select" (like regular select behaviour where you can select only one item), and "check" (where multiple items check/select is permitted) -->
          <label>
            @if (type() === 'select') {
              <input
                type="radio"
                (click)="optionOnClick(option.id)"
                name="{{ selectId }}"
                [checked]="selectedOption?.id === option.id"
              />
            } @else if (type() === 'check') {
              <!-- Check Mode -->
              <input
                type="checkbox"
                (click)="optionOnClick(option.id)"
                name="{{ option + ' checkBox' }}"
                value="23"
                [checked]="option?.checked"
              />
            }

            <span class="value">{{ option.value }}</span>
          </label>
        </li>
      }
    </ul>
  </div>
</div>
